// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"49603758","253":"2acc9fab","684":"271b4cb9","878":"ecd9fc1c"}[chunkId] + ".chunk.js";
};